var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.makeupLessons = {
    attach: function (context) {
      var $mlPage = $('.makeup-lesson-page', context);
      var $faceChart = $('.makeup-lesson__event', $mlPage);
      var $videoCta = $('.js-link--custom-get-the-look', $mlPage);
      var $steps = $('.makeup-lesson__step', $mlPage);
      var $slides = $('.makeup-lesson-page__slider-slide', $mlPage);
      var $carousel = $('.js-lesson-carousel', $mlPage);
      var $showProductsLinks = $('.js-shop-all-products', $mlPage);
      var $carouselContent = $('.makeup-lesson-page__content-container', $mlPage);
      var $carouselContentSlides = $('.makeup-lesson-page__content-wrap', $carouselContent);
      var $headers = $('.makeup-lesson__step-header', $mlPage);
      var slideToShow = window.location.href.split('#')[1];
      var initedCarousel = false;

      // On load hide all the lessons
      $carouselContentSlides.fadeOut();

      // When the video CTA is clicked, we do our custom scroll to the first step
      $videoCta.on('click', function (e) {
        var $activeContentSlide = $('.makeup-lesson-page__content-wrap.active', $mlPage);

        $('html, body').animate({
          scrollTop: $('.makeup-lesson__step', $activeContentSlide).first().offset().top - 100
        }, 600);
      });
      // We have less than 2 makeup lessons, hide the carousel
      if ($slides.length < 2) {
        $carousel.hide();
      }
      $carousel.slick({
        rtl: site.direction.isRTL,
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 100,
        draggable: false,
        infinite: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }
        ],
        onInit: function (carousel) {
          if (initedCarousel) {
            return false;
          }
          initedCarousel = true;
          var _slideToShow = slideToShow;

          // We want to start off on a particular slide
          if (_slideToShow) {
            _slideToShow--; // The hash uses 1 as the starting index, so subtract 1 to start from 0
            var slideIndex = parseInt(_slideToShow);

            // If our hash value is a number, go to that makeup lesson slide
            // Use slick-showing to toggle opacity
            if (!isNaN(_slideToShow) && _slideToShow > 0) {
            // Not sure why this is necessary. slickGoTo would not go to the 2nd page if user lands on lesson 6
            // and lesson 6 is on page 2 of carousel
              var slidesPerPage = 3;

              if (Unison.fetch.now().name == 'medium' || Unison.fetch.now().name == 'large') {
                slidesPerPage = 5;
              }
              // How many times do we have to click the next button ?
              // Each click goes forward one slide
              var slickNextCounter = slideIndex - slidesPerPage;

              // Add one because slide 3 is on page 2, so if we want to go to slide 3 on 
              // mobile we want 0 to mean go forward one page
              if (slickNextCounter >= 0) {
                slickNextCounter++;
                for (var i = 0; i < slickNextCounter; i++) {
                // I have no idea why this wouldnt work without the setTimeout
                  setTimeout(function () {
                    $carousel.slickNext();
                  }, 400 * (i + 1));
                }
              }
              // End the manual toggling of slick pages
              $slides.eq(slideIndex).addClass('slick-showing');
              $slides.eq(slideIndex).trigger('click');
              $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
              $carouselContentSlides.eq(slideIndex).stop(true, true).fadeIn().addClass('active');
            } else {
              $slides.eq(0).addClass('slick-showing');
              $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
            }
            // Else start from first slide
          } else {
            $slides.eq(0).addClass('slick-showing');
            $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
          }
        }
      });

      // Manual changing of slide content
      $('.makeup-lesson-page__slide-wrap', $carousel).on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('slick-showing')) {
          return false;
        }
        var $activeSlide = $(this).closest('.makeup-lesson-page__slider-slide');

        $slides.not($activeSlide).removeClass('slick-showing');
        $activeSlide.addClass('slick-showing');
        $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
        $carouselContentSlides.eq($activeSlide.index()).stop(true, true).fadeIn().addClass('active');
        $carouselContentSlides.filter('.active').find('.slick-slider').get(0).slick.setPosition();
      });

      // When mobile headers are clicked, do the expanding of the accordion
      // If one is closing, hide the product grid as well
      $headers.on('click', function () {
        var $info = $('.makeup-lesson__step-info', $(this).parent());

        $info.stop(true, true).slideToggle().toggleClass('active');
        $info.parent().toggleClass('active');
        if (!$info.parent().hasClass('active')) {
          $('.makeup-lesson__step-product-grid', $info.parent()).slideUp();
        }
      });

      // Show the product grid on clicking the CTA within the step
      $steps.each(function () {
        var $me = $(this);
        var $button = $('.js-button', $(this));
        var $grid = $('.makeup-lesson__step-product-grid', $(this));
        var $closeButton = $('.js-close', $me);

        // Once page has loaded slide up the grid, this is to allow proper widths and heights
        $grid.slideUp();
        $button.on('click', function (e) {
        // Find other grids in the steps
        // Close the ones that are not this
          var $otherGrids = $('.makeup-lesson__step-product-grid', $steps);

          $otherGrids = $otherGrids.not($grid);
          $(this).toggleClass('active').attr('aria-expanded', $this.attr('aria-expanded') === 'true' ? 'false' : 'true');
          // This supposedly fixes the product carousel sizing issue
          $grid.slideToggle();
          $('.js-product-carousel', $me)[0].slick.setPosition();
          productGridHeights($me);
          $otherGrids.stop(true, true).hide();
          $('html, body').animate({
            scrollTop: $grid.offset().top - 150
          }, 500);
          $('.js-button.active', $steps).not($(this)).removeClass('active');

          e.preventDefault();
        });

        $closeButton.on('click', function (e) {
          $button.trigger('click');
          $button.focus();
        });

        // Keydown for close button
        $closeButton.on('keydown', function (e) {
          if (site.getKeycode(e) === 13) {
            $(this).trigger('click');
          }
        });
      });

      // This is the bottom link that sometimes says 'shop all products'
      // Samething as above, once window loads slide up the product grid
      $showProductsLinks.each(function () {
        $(this).parent().find('.makeup-lesson-page__shop-all-products__grid').slideUp();
        $(this).on('click', function (e) {
          e.preventDefault();
          $(this).parent().toggleClass('active');
          $(this).parent().find('.makeup-lesson-page__shop-all-products__grid').stop(true, true).slideToggle();
          $('.js-product-carousel', $(this).parent())[0].slick.setPosition();
          productGridHeights($(this).parent());
        });
      });

      // Face chart template
      $faceChart.each(function () {
        var $me = $(this);
        var $faceChartCta = $('.js-makeup-lesson-event-trigger', $me);
        var $close = $('.js-close', $me);
        var $grid = $(this).find('.makeup-lesson__event-product-grid');

        $grid.slideUp();

        $faceChartCta.on('click', function (e) {
          e.preventDefault();
          $grid.slideToggle();
          $grid.find('.js-product-carousel')[0].slick.setPosition();
          productGridHeights($grid);
          $('html, body').animate({
            scrollTop: $grid.offset().top - 150
          }, 500);
          $(this).toggleClass('active');
        });

        $close.on('click', function () {
          $grid.slideUp();
          $faceChartCta.removeClass('active');
        });
      });

      // Find the product grid, match their heights
      function productGridHeights($elem) {
        $('.product-grid__item', $elem).matchHeight();
      }
    }
  };
})(jQuery);
